// extracted by mini-css-extract-plugin
module.exports = {"SummaryBox":"SummaryBox_SummaryBox__2Yniz","CurrentValues":"SummaryBox_CurrentValues__1ElKm","Caption":"SummaryBox_Caption__12a16","Value":"SummaryBox_Value__3B13O"};